import axios from 'axios';
import { apiClient } from './client.api';
import { CourseOption  } from '../../types/course.response';

export const searchApi = {
    searchCourses: async (query: string, semester?: string): Promise<CourseOption[]> => {
        const params = semester ? `q=${query}&semester=${semester}` : `q=${query}`;
        const response = await apiClient.get(`/search/courses?${params}`);
        return response.data.data;
    },
};